import {ECurrency, TCurrency} from '@edna/utils';

import {EChannelType} from 'src/constants';

export enum ELicenseStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  ACTIVE_DEBT = 'ACTIVE_DEBT',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  TEMPORARY_BLOCKED = 'TEMPORARY_BLOCKED',
}

export enum ELicensePeriod {
  YEAR = 12,
  MONTH = 1,
}

export type TLicenseStatus = keyof typeof ELicenseStatus;

export type TCommonLicense = {
  id: number;
  channelType: EChannelType;
  tenantId: number;
  name: string;
  description: string;
  price: number;
  currency: TCurrency;
  status: TLicenseStatus;
  createdAt: string;
  updatedAt: string;
  activatedAt: string;
  expiredAt: string;
  cancelledAt: string;
  scheduledCancelAt?: string;
  activeUntil: string;
  paidUntil: string;
  temporaryblockedAt: string;
};

export type TWhatsAppLicense = TCommonLicense & {
  channelType: EChannelType.WHATSAPP;
  subjectId: number;
  tariffMauCount?: number;
  remainingMauCount?: number;
  amauCount?: number;
};

export type TSimpleLicense = TCommonLicense & {
  channelType:
    | EChannelType.VIBER
    | EChannelType.SMS
    | EChannelType.MAX
    | EChannelType.MAX_BOT
    | EChannelType.TELEGRAM;
  periodMonths: number;
};

export type TLicense = TWhatsAppLicense | TSimpleLicense;

export enum EPaymentType {
  INIT = 'INIT',
  CONNECTION_FEE = 'CONNECTION_FEE',
  RENEWAL = 'RENEWAL',
}

export type TCommonPayment = {
  currency: ECurrency;
  price: number;
};

export type TInitPayment = TCommonPayment & {
  paymentType: EPaymentType.INIT;
  periodEndedAt: string;
  periodStartedAt: string;
};
export type TRenewalPayment = TCommonPayment & {
  paymentType: EPaymentType.RENEWAL;
  periodEndedAt: string;
  periodStartedAt: string;
};
export type TConnectionPayment = TCommonPayment & {
  paymentType: EPaymentType.CONNECTION_FEE;
};

export type TApproximatePayment = TInitPayment | TRenewalPayment | TConnectionPayment;
